const environment = {
  debug: true,
  baseUrl: "https://lands.canguru.dev/api/",
  phoneNumber: "+61 423 595 471",
  mapboxToken:
    "pk.eyJ1IjoibG91YXkxMiIsImEiOiJja3l4OGU3bTgwZzJmMzJxbHRoOThqajV3In0.QO67TwPdnpBXiBVpMAfmkA",
};

export default environment;
